<div class="placeholder-page">
  <ima-module-header />

  <p class="placeholder-page-message">{{ i18n.t('placeholder.description') }}</p>
</div>
